import { MemberProps } from 'app/components/Core/convention'
import React, { ImgHTMLAttributes } from 'react'

const machineIconLocation = '/assets/images/icons/machine_icon.svg'

const LineItemImage: React.FC<
  MemberProps<Pick<ILineItem, 'name' | 'image_url' | 'imageUrl'>, ImgHTMLAttributes<unknown>>
> = ({ member, props }) => {
  const { height, width, ...others } = props || {}

  const defaultDimensions = React.useMemo(
    () => (height || width ? { height, width } : { height: 45, width: 60 }),
    [height, width]
  )

  const url = member.imageUrl || member.image_url

  return (
    <img
      src={url || machineIconLocation}
      alt={member.name}
      style={{ objectFit: 'contain' }}
      loading="lazy"
      {...defaultDimensions}
      {...others}
    />
  )
}

export default LineItemImage
